import {ForYouReviewCommentItem} from '../commenting/review-comments/ForYouReviewComment'
import {useCommentReviews} from './data/use-comment-reviews'

export function CommentReview() {
  const commentReviews = useCommentReviews()

  if (commentReviews.length === 0) {
    return null
  }

  return (
    <>
      {commentReviews.map(reviewSummary => (
        <ForYouReviewCommentItem key={reviewSummary.id} reviewSummary={reviewSummary} />
      ))}
    </>
  )
}
